import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';

export type AttachmentEntityType = 'JOURNAL_ENTRY' | 'SUPPLIER_BILL' | 'SALES_INVOICE' | 'BILL_OF_ENTRY'
  | 'CORPORATE_TAX_COMPUTATION' // W3-G
  | 'CLOSE_TASK' | 'COMPLIANCE_TASK' // W3-R
  | 'EXP_OVERDUE_CASE' // W3-W
  | 'CARD_STATEMENT' // W3-U
  | 'INTERCOMPANY_TXN' // W3-M
  | 'DELIVERY_CHALLAN' // W3-O
  | 'RECEIPT' | 'SUPPLIER_PAYMENT' | 'PURCHASE_ORDER' | 'GOODS_RECEIPT' | 'EXP_FORM' | 'EXPORT_LC' | 'FIXED_ASSET' // W3-K
  | 'CUSTOMER' | 'LEAD' | 'OPPORTUNITY'; // S4

/** S4: what a customer / lead / opportunity attachment is. */
export type AttachmentDocumentKind = 'BUSINESS_CARD' | 'TRADE_LICENCE' | 'NID' | 'TIN' | 'BIN' | 'OTHER';

export const CRM_ATTACHMENT_KINDS: { value: AttachmentDocumentKind; label: string }[] = [
  { value: 'BUSINESS_CARD', label: 'Business card' },
  { value: 'TRADE_LICENCE', label: 'Trade licence' },
  { value: 'NID', label: 'NID' },
  { value: 'TIN', label: 'TIN certificate' },
  { value: 'BIN', label: 'BIN certificate' },
  { value: 'OTHER', label: 'Other' },
];

export interface Attachment {
  id: string;
  entityType: AttachmentEntityType;
  entityId: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  uploadedByName?: string;
  createdAt: string;
  documentKind?: AttachmentDocumentKind | null;
}

export const AttachmentService = {
  list: async (entityType: AttachmentEntityType, entityId: string): Promise<Attachment[]> =>
    (await axios.get(ENDPOINTS.ATTACHMENT.BASE, { params: { entityType, entityId } })).data,
  upload: async (entityType: AttachmentEntityType, entityId: string, file: File, kind?: AttachmentDocumentKind): Promise<Attachment> => {
    const form = new FormData();
    form.append('file', file);
    form.append('entityType', entityType);
    form.append('entityId', entityId);
    if (kind) form.append('kind', kind);
    return (await axios.post(ENDPOINTS.ATTACHMENT.BASE, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  download: async (id: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.ATTACHMENT.DOWNLOAD(id), { responseType: 'blob' })).data,
  updateKind: async (id: string, kind: AttachmentDocumentKind): Promise<Attachment> =>
    (await axios.patch(ENDPOINTS.ATTACHMENT.KIND(id), null, { params: { kind } })).data,
  remove: async (id: string): Promise<void> => {
    await axios.delete(ENDPOINTS.ATTACHMENT.DELETE(id));
  },
};
